import React, { useEffect } from 'react';

import Sidebar from './Sidebar'//import $ from "jquery";

import { Link } from 'react-router-dom';
import ImageR from '../assets/img/Icons/Icons/image.png'

import ImageQ from '../assets/img/Icons/Icons/imageQ.png'
import ImageC from '../assets/img/Icons/Icons/imagechat.png'

import Barside from '../assets/img/Icons/Icons/Icon-17.png'
import Barcodes from '../assets/img/Icons/Icons/checkoutbarcode.png'
import Footer from '../pages/footer'
const Profile = () => {


    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, [])


    return (
        <div>
            <div className="bg-white border shadow  bg-bottom-round">
                <div className="container page17">
                    <div className="row mt-3">
                    <div className="col-sm-1-my17 ">
                        <Sidebar/>
                            {/* <p className="mb-0"><img src={Barside} className="Barside" alt="" /></p> */}
                        </div>
                      
                        <div className="col-sm-11-my17 text-center ">

                            <h5 className=" signin1-h1-top  mb-0">Profile</h5>
                        </div>

                    </div>

                    <div className="row ">
                        <div className="col-sm-12 py-2">
                            <hr className="mt-2 mb-1" />

                            <div className="row px-3 " >
                                <div className="col-sm-12 text-center">
                                    <p className="text-red mb-1 "><small className="fw600">MEMBER #:5887456</small></p>
                                    <div>
                                        <img src={Barcodes} className="Profile-barcode" alt="" />
                                    </div>
                                </div>
                                <div className="col-sm-12">

                                    <form action="" className="profile-form mt-4">
                                        <div className="row">
                                            <div className="col">
                                                <div className="form-group">
                                                    <label for="exampleInputEmail1">First Name </label>
                                                    <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="First Name" />
                                                </div>

                                            </div>
                                            <div className="col">
                                                <div className="form-group">
                                                    <label for="exampleInputEmail1">Last Name </label>
                                                    <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Last Name" />
                                                </div>

                                            </div>
                                        </div>
                                        <div className="row ">
                                            <div className="col">
                                                <div className="form-group">
                                                    <label for="exampleInputEmail1">Phone Number </label>
                                                    <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Phone Number " />
                                                </div>

                                            </div>
                                            <div className="col">
                                                <div className="form-group">
                                                    <label for="exampleInputEmail1">Zip code</label>
                                                    <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Zip Code" />
                                                </div>

                                            </div>
                                            <div className="col-sm-12 mt-3">
                                                <label className="">Username</label>
                                                <div>
                                                    <p className="d-inline mb-0"><small className="text-secondary-light-gray">username@.com</small></p>
                                                    <p className="float-right d-inline mb-0"><a href="" className="float-right">
                                                        <small className="text-danger ">Change</small></a> </p>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mt-2">
                                                <label className="">Store</label>
                                                <div>
                                                    <p className="d-inline mb-0"><small className="text-secondary-light-gray">Ren Market</small></p>
                                                    <p className="float-right d-inline mb-0"><a href="" className="float-right">
                                                        <small className="text-danger ">Change</small></a> </p>
                                                </div>
                                            </div>

                                        </div>
                                    </form>

                                </div>

                                <div className="col-sm-12 bottom-btm-font mt-4 text-center">
                                    <button type="button" className="btn btn-success w-100 mt-3 pt-1 pb-1 "><small>Save</small></button>
                                    <div className="row mx-auto mb-2">
                                        <div className="col  pl-0 pr-1">
                                            <button type="button" className="btn btn-outline-danger w-100 px-0 mt-2 py-0 text-center" ><small className="fw600">Change PIN</small></button>
                                        </div>
                                        <div className="col pr-0 pl-1">
                                            <button type="button" className="btn btn-outline-danger w-100 mt-2 py-0 text-center" ><small className="fw600">Logout</small></button>
                                        </div>
                                    </div>
                                    <Link to="Messages" className=" text-center text-decoration-none text-danger  profile-msg-link"><i className="fa fa-envelope-o text-danger pr-2" aria-hidden="true"></i>Messages</Link>
                                </div>

                              </div>

                              <div className="row mt-3 px-3">
                                        <div className="col">
                                            <a href="" className="bottom-s1-link text-decoration-none" >Support</a>
                                        </div>
                                        <div className="col">
                                            <a href="" className="bottom-s1-link text-decoration-none float-right mt-1" >Legal & Privacy</a>
                                        </div>
                                    </div>
    
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}

export default Profile;

